(() => {
  if (customElements.get('dvalia-mask-product')) return;
  class DvaliaMaskProduct extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      try { this.data = JSON.parse(this.querySelector('[data-mask-product-data]').textContent); } catch { return; }
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-mask-submit]');
      this.quantity = this.form.elements.quantity;
      this.status = this.querySelector('[data-mask-status]');
      const options = { signal: this.controller.signal };
      this.gallery = this.querySelector('[data-mask-gallery]');
      this.galleryButtons = [...this.querySelectorAll('[data-mask-image]')];
      this.galleryArrows = [...this.querySelectorAll('[data-mask-gallery-step]')];
      const selectImage = (index) => {
        const slide = this.gallery.children[index];
        if (!slide || slide.hidden) return;
        this.gallery.scrollTo({ left: index * this.gallery.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.galleryButtons.forEach(button => button.addEventListener('click', () => selectImage(Number(button.dataset.maskImage)), options));
      this.galleryArrows.forEach(button => button.addEventListener('click', () => {
        const count = [...this.gallery.children].filter(slide => !slide.hidden).length;
        if (count < 2) return;
        const current = Math.round(this.gallery.scrollLeft / Math.max(1, this.gallery.clientWidth));
        selectImage((current + Number(button.dataset.maskGalleryStep) + count) % count);
      }, options));
      this.gallery.addEventListener('scroll', () => {
        const current = Math.round(this.gallery.scrollLeft / Math.max(1, this.gallery.clientWidth));
        this.galleryButtons.forEach((button, index) => button.setAttribute('aria-current', String(index === current)));
      }, { ...options, passive: true });
      this.gallery.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const current = Math.round(this.gallery.scrollLeft / Math.max(1, this.gallery.clientWidth));
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : Math.max(0, Math.min(1, current + (event.key === 'ArrowRight' ? 1 : -1)));
        selectImage(target);
      }, options);
      this.form.addEventListener('change', (event) => {
        if (event.target.name === 'id') {
          this.render();
          const url = new URL(window.location.href);
          url.searchParams.set('variant', String(this.variant.id));
          window.history.replaceState({}, '', url);
        }
      }, options);
      this.form.addEventListener('submit', async (event) => {
        const cart = document.querySelector('dvalia-cart');
        if (!cart?.addItems) return;
        event.preventDefault();
        if (this.pending || this.button.disabled || !this.variant?.available || !this.form.reportValidity()) return;
        const quantity = Number(this.quantity.value);
        if (!Number.isSafeInteger(quantity) || quantity < 1 || (this.variant.stock !== null && quantity > this.variant.stock)) return;
        this.pending = true;
        this.button.disabled = true;
        this.button.textContent = this.data.adding;
        this.status.textContent = '';
        try { await cart.addItems([{ id: this.variant.id, quantity }]); }
        catch (error) { if (error.name !== 'AbortError') this.status.textContent = error.message || this.data.error; }
        finally { if (this.isConnected) { this.pending = false; this.render(); } }
      }, options);
      this.render();
    }
    render() {
      this.variant = this.data.variants.find(variant => variant.id === Number(this.form.querySelector('[name="id"]:checked')?.value));
      const variant = this.variant;
      if (!variant) { this.button.disabled = true; return; }
      const image = this.querySelector('.dv-mask-product-image');
      if (image.getAttribute('src') !== variant.image) {
        image.removeAttribute('srcset');
        image.src = variant.image;
      }
      image.alt = variant.alt;
      const insideSlide = this.querySelector('[data-mask-inside-slide]');
      const insideImage = insideSlide.querySelector('img');
      insideSlide.hidden = !variant.insideImage;
      this.querySelector('[data-mask-gallery-nav]').hidden = !variant.insideImage;
      this.galleryArrows.forEach(button => { button.hidden = !variant.insideImage; });
      if (insideImage && variant.insideImage) {
        if (insideImage.getAttribute('src') !== variant.insideImage) {
          insideImage.removeAttribute('srcset');
          insideImage.src = variant.insideImage;
        }
        insideImage.alt = variant.insideAlt;
      }
      if (this.galleryVariantId !== variant.id) {
        this.gallery.scrollLeft = 0;
        this.galleryButtons.forEach((button, index) => button.setAttribute('aria-current', String(index === 0)));
        this.galleryVariantId = variant.id;
      }
      this.querySelector('[data-mask-price]').textContent = variant.price;
      if (variant.stock === null) this.quantity.removeAttribute('max');
      else this.quantity.max = String(variant.stock);
      this.button.disabled = this.pending || !variant.available || this.dataset.salesEnabled !== 'true';
      this.button.textContent = this.pending ? this.data.adding : variant.available ? this.data.add : this.data.soldOut;
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('dvalia-mask-product', DvaliaMaskProduct);
})();
